import plotDefaultStyle from "../constants/plot"

class Base {

    constructor(options) {
        options = options || {};
        this.options = options;
        this.Cesium = options.Cesium || Cesium; //Cesium对象
        this.viewer = options.viewer || viewer; //场景对象
    }
    guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    lockCamera() {
        this.viewer.scene.screenSpaceCameraController.enableRotate = false;
        this.viewer.scene.screenSpaceCameraController.enableTilt = false;
        this.viewer.scene.screenSpaceCameraController.enableTranslate = false;
        this.viewer.scene.screenSpaceCameraController.enableInputs = false;
    }

    unLockCamera() {
        this.viewer.scene.screenSpaceCameraController.enableRotate = true;
        this.viewer.scene.screenSpaceCameraController.enableTilt = true;
        this.viewer.scene.screenSpaceCameraController.enableTranslate = true;
        this.viewer.scene.screenSpaceCameraController.enableInputs = true;
    }
    getCatesian3FromPX(px) {
        var cartesian;
        var depthTest = this.viewer.scene.globe.depthTestAgainstTerrain; //开启地形监测
        if (depthTest) {
            cartesian = this.viewer.scene.pickPosition(px);
            if (cartesian) {
                return cartesian;
            }
        }
        var ray = this.viewer.camera.getPickRay(px);
        if (!ray) return null;
        cartesian = this.viewer.scene.globe.pick(ray, this.viewer.scene);
        return cartesian;
    }
    getDefaultStyle(type) {
        type = type || this.getType();
        return plotDefaultStyle[type] || {};
    }

    //合并样式
    unionStyle(style) {
        var conifgStyle = this.options.style || this.getDefaultStyle(); //默认配置，低级别
        var unionStyle = { ...conifgStyle, ...style };
        return unionStyle;
    }

    createEnityById(id) {
        var $this = this;
        let entity = new $this.Cesium.Entity({
            id: id
        });
        return entity;
    }

    createEnity() {
        var $this = this;
        let entity = new $this.Cesium.Entity();
        return entity;
    }

    createPoint(style) {
        var point = { ...this.unionStyle(style) };
        return point;
    }

    createPolyline(positions, style) {
        style = style || {};
        var polyline = {
            positions: positions,
            ...this.unionStyle(style)

        };
        return polyline;
    }

    createPolygon(hierarchyProperty, style) {
        style = style || {};
        var polygon = {
            hierarchy: hierarchyProperty,
            ...this.unionStyle(style)

        };
        return polygon;
    }

    createRectangle(coordinatesProperty, style) {
        style = style || {};
        var rectangle = {
            coordinates: coordinatesProperty,
            rotation: 0,
            stRotation: 0,
            ...this.unionStyle(style)

        };
        return rectangle;
    }

    createEllipse(semiAxisProperty, style) {
        style = style || {};
        var ellipse = {
            semiMinorAxis: semiAxisProperty,
            semiMajorAxis: semiAxisProperty,
            ...this.unionStyle(style)
        }
        return ellipse;
    }

    createEllipsoid(rProperty, style) {
        var ellipsoid = {
            radii: rProperty,
            ...this.unionStyle(style)
        }
        return ellipsoid;
    }

    //创建圆锥
    createCone(lengthProperty, bottomRadiusProperty, style) {
        var cylinder = {
            length: lengthProperty,
            bottomRadius: bottomRadiusProperty,
            ...this.unionStyle(style)
        }
        return cylinder;
    }

    //创建墙体
    createWall(positionsProperty, minimumHeightsProperty, maximumHeightsProperty, style) {
        var wall = {
            positions: positionsProperty,
            minimumHeights: minimumHeightsProperty,
            maximumHeights: maximumHeightsProperty,
            ...this.unionStyle(style)
        }
        return wall;
    }

    //创建管道
    createPolylineVolume(positionsProperty, shapeProperty, style) {
        var polylineVolume = {
            positions: positionsProperty,
            shape: shapeProperty,
            ...this.unionStyle(style)
        }
        return polylineVolume;
    }


    ///---------工具类----------////
    getPickEnity(pick) {
        if (Cesium.defined(pick) && (pick.id)) {
            return pick.id;
        }

        return null;
    }

    cart2Wgs84(cartesain3Array) {
        let cartographics = Cesium.Ellipsoid.WGS84.cartesianArrayToCartographicArray(cartesain3Array);
        return cartographics.map(carto => {
            return [Cesium.Math.toDegrees(carto.longitude), Cesium.Math.toDegrees(carto.latitude)]
        })
    }
    //获取中心点
    getCenter(arr) {
        let centerLonLat = []
        if (arr.length) {
            const lon = []
            const lat = []
            const poly = [];
            for (let i = 0, len = arr.length; i < len; i++) {
                lon.push(arr[i][0])
                lat.push(arr[i][1])
            }
            for (let i = 0, len = lon.length; i < len; i++) {
                poly.push({
                    x: parseFloat(lon[i]),
                    y: parseFloat(lat[i]),
                    z: 0
                });
            }
            const sortedLongitudeArray = poly.map(item => item.x).sort();
            const sortedLatitudeArray = poly.map(item => item.y).sort();
            const centerLongitude = ((parseFloat(sortedLongitudeArray[0]) + parseFloat(sortedLongitudeArray[sortedLongitudeArray.length - 1])) / 2).toFixed(14);
            const centerLatitude = ((parseFloat(sortedLatitudeArray[0]) + parseFloat(sortedLatitudeArray[sortedLatitudeArray.length - 1])) / 2).toFixed(14);
            centerLonLat = [Number(centerLongitude), Number(centerLatitude)]
        }
        return centerLonLat;
    }

    //获取外接矩形
    getRectangle(positions) {
        var rectangle = Cesium.Rectangle.fromCartesianArray(positions);
        var west = rectangle.west;
        var south = rectangle.south;
        var east = rectangle.east;
        var north = rectangle.north;

        var topLeft = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(west), Cesium.Math.toDegrees(north));
        var topRight = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(east), Cesium.Math.toDegrees(north));
        var bottomLeft = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(west), Cesium.Math.toDegrees(south));
        var bottomRight = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(east), Cesium.Math.toDegrees(south));

        return [topLeft, topRight, bottomLeft, bottomRight];
    }

    //获取以center为中心的A和B坐标夹角，有方向
    getAngleCenterPointDir(center, pointA, pointB) {
        //以点为原点建立局部坐标系（东方向为x轴,北方向为y轴,垂直于地面为z轴），得到一个局部坐标到世界坐标转换的变换矩阵
        const localToWorld_Matrix = Cesium.Transforms.eastNorthUpToFixedFrame(center);
        //求世界坐标到局部坐标的变换矩阵
        const worldToLocal_Matrix = Cesium.Matrix4.inverse(
            localToWorld_Matrix,
            new Cesium.Matrix4()
        );
        //a点在局部坐标的位置，其实就是局部坐标原点
        const localPosition_A = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointA,
            new Cesium.Cartesian3()
        );
        //B点在以A点为原点的局部的坐标位置
        const localPosition_B = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointB,
            new Cesium.Cartesian3()
        );

        //弧度
        const angle1 = Math.atan2(localPosition_A.x - 1, localPosition_A.y - 0);
        const angle2 = Math.atan2(localPosition_B.x - 1, localPosition_B.y - 0);

        const angle = angle2 - angle1;

        //角度
        //let theta = angle * (180 / Math.PI);
        // if (theta < 0) {
        //   theta = theta + 360;
        // }
        return angle;
    }

    //获取以center为中心把point1旋转angle角度后的新坐标，有方向
    getRotateCenterPoint(center, point1, angle) {
        if (angle == 0) {
            return point1;
        }
        // 计算center的地面法向量
        var chicB = Cesium.Cartographic.fromCartesian(center);
        chicB.height = 0;
        var dB = Cesium.Cartographic.toCartesian(chicB);

        var chicC = Cesium.Cartographic.fromCartesian(center);
        chicC.height = 10;
        var dC = Cesium.Cartographic.toCartesian(chicC);

        var normaB = Cesium.Cartesian3.normalize(
            Cesium.Cartesian3.subtract(dB, dC, new Cesium.Cartesian3()),
            new Cesium.Cartesian3()
        );

        // 构造基于center的法向量旋转angle度的矩阵
        var Q = Cesium.Quaternion.fromAxisAngle(normaB, Cesium.Math.toRadians(angle));
        var m3 = Cesium.Matrix3.fromQuaternion(Q);
        var m4 = Cesium.Matrix4.fromRotationTranslation(m3);

        // 计算point1点相对center点的坐标A1
        var A1 = Cesium.Cartesian3.subtract(point1, center, new Cesium.Cartesian3());

        //对A1应用旋转矩阵
        var p = Cesium.Matrix4.multiplyByPoint(m4, A1, new Cesium.Cartesian3());
        // 新点的坐标
        var pointNew = Cesium.Cartesian3.add(p, center, new Cesium.Cartesian3());

        return pointNew;
    }

    //获取点的offest平移矩阵后点
    getPositionTranslation(position, offest, degree, type, fixedFrameTransform) {
        fixedFrameTransform = fixedFrameTransform || Cesium.Transforms.eastNorthUpToFixedFrame;

        var rotate = Cesium.Math.toRadians(-Cesium.defaultValue(degree, 0)); //转成弧度

        type = (type || "z").toUpperCase();
        var _normal = Cesium.Cartesian3["UNIT_" + type];

        var quaternion = Cesium.Quaternion.fromAxisAngle(_normal, rotate); //quaternion为围绕这个z轴旋转d度的四元数
        var rotateMatrix3 = Cesium.Matrix3.fromQuaternion(quaternion); //rotateMatrix3为根据四元数求得的旋转矩阵

        var pointCartesian3 = new Cesium.Cartesian3(Cesium.defaultValue(offest.x, 0), Cesium.defaultValue(offest.y, 0), Cesium.defaultValue(offest.z, 0)); //point的局部坐标
        var rotateTranslationMatrix4 = Cesium.Matrix4.fromRotationTranslation(rotateMatrix3, Cesium.Cartesian3.ZERO); //rotateTranslationMatrix4为旋转加平移的4x4变换矩阵，这里平移为(0,0,0)，故填个Cesium.Cartesian3.ZERO
        Cesium.Matrix4.multiplyByTranslation(rotateTranslationMatrix4, pointCartesian3, rotateTranslationMatrix4); //rotateTranslationMatrix4 = rotateTranslationMatrix4  X  pointCartesian3
        var originPositionCartesian3 = Cesium.Ellipsoid.WGS84.cartographicToCartesian(Cesium.Cartographic.fromCartesian(position)); //得到局部坐标原点的全局坐标
        var originPositionTransform = fixedFrameTransform(originPositionCartesian3); //m1为局部坐标的z轴垂直于地表，局部坐标的y轴指向正北的4x4变换矩阵
        Cesium.Matrix4.multiplyTransformation(originPositionTransform, rotateTranslationMatrix4, rotateTranslationMatrix4); //rotateTranslationMatrix4 = rotateTranslationMatrix4 X originPositionTransform
        var pointCartesian = new Cesium.Cartesian3();
        Cesium.Matrix4.getTranslation(rotateTranslationMatrix4, pointCartesian); //根据最终变换矩阵m得到p2
        return pointCartesian;
    }

    cartesianToLatlng(cartesian) {
        var latlng = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesian);
        var lat = this.Cesium.Math.toDegrees(latlng.latitude);
        var lng = this.Cesium.Math.toDegrees(latlng.longitude);
        return [lng, lat];
    }

    distance(pnt1, pnt2) {
        return (Math.sqrt(Math.pow((pnt1[0] - pnt2[0]), 2) + Math.pow((pnt1[1] - pnt2[1]), 2)))
    }

    calcGlobeHeight(positions, height = 0) {

        var arr = [];
        for (var i = 0, len = positions.length; i < len; i++) {
            var carto = Cesium.Cartographic.fromCartesian(positions[i]);
            var heightTerrain = this.viewer.scene.globe.getHeight(carto);
            var point = Cesium.Cartesian3.fromRadians(carto.longitude, carto.latitude, heightTerrain + height);
            arr.push(point);
        }
        return arr;
    }

}

export default Base;